import type { SupportedLocales } from '#shared/types/locales'
import type { SeoEvent } from '~/types/rental-api-aliases'

type SeoEventCategoryType = NonNullable<SeoEvent['EventType']>

type EventCategoryDefinition = {
  type: SeoEventCategoryType
  slug: Record<SupportedLocales, string>
  image: string
}

const EVENT_CATEGORY_BASE_PATH = 'marketing/events/images/categories'

/** Single source of truth for event category type, localized URL slugs, and hero image. */
const EVENT_CATEGORY_DEFINITIONS: EventCategoryDefinition[] = [
  { type: 'Exhibition', slug: { en: 'exhibition', fr: 'exposition' }, image: `${EVENT_CATEGORY_BASE_PATH}/Exhibition.jpg` },
  { type: 'Festival', slug: { en: 'festival', fr: 'festival' }, image: `${EVENT_CATEGORY_BASE_PATH}/Festival.jpg` },
  { type: 'Motorsport', slug: { en: 'motorsport', fr: 'sport-automobile' }, image: `${EVENT_CATEGORY_BASE_PATH}/Motorsport.jpg` },
  { type: 'Music', slug: { en: 'music', fr: 'musique' }, image: `${EVENT_CATEGORY_BASE_PATH}/Music.jpg` },
  { type: 'Sport', slug: { en: 'sport', fr: 'sport' }, image: `${EVENT_CATEGORY_BASE_PATH}/Sport.jpg` },
  { type: 'AirShow', slug: { en: 'air-show', fr: 'spectacle-aerien' }, image: `${EVENT_CATEGORY_BASE_PATH}/AirShow.jpg` },
  { type: 'SeasonalExperience', slug: { en: 'seasonal-experience', fr: 'experience-saisonniere' }, image: `${EVENT_CATEGORY_BASE_PATH}/SeasonalExperience.jpg` },
  { type: 'Other', slug: { en: 'other', fr: 'autre' }, image: `${EVENT_CATEGORY_BASE_PATH}/Other.jpg` },
]

const enSlugToType: Record<string, SeoEventCategoryType> = {}
const frSlugToType: Record<string, SeoEventCategoryType> = {}
const categoryImages = {} as Record<SeoEventCategoryType, string>

for (const { type, slug, image } of EVENT_CATEGORY_DEFINITIONS) {
  enSlugToType[slug.en] = type
  frSlugToType[slug.fr] = type
  categoryImages[type] = image
}

Object.freeze(enSlugToType)
Object.freeze(frSlugToType)

export const EVENT_TYPE_BY_SLUG: Record<SupportedLocales, Record<string, SeoEventCategoryType>> = {
  en: enSlugToType,
  fr: frSlugToType,
}
Object.freeze(EVENT_TYPE_BY_SLUG)
export type EVENT_TYPE_BY_SLUG = typeof EVENT_TYPE_BY_SLUG

export const EVENT_CATEGORY_SLUGS: { type: SeoEventCategoryType, slug: Record<SupportedLocales, string> }[]
  = EVENT_CATEGORY_DEFINITIONS.map(({ type, slug }) => ({ type, slug }))
Object.freeze(EVENT_CATEGORY_SLUGS)
export type EVENT_CATEGORY_SLUGS = typeof EVENT_CATEGORY_SLUGS

export const EVENT_CATEGORY_IMAGES: Record<SeoEventCategoryType, string> = categoryImages
Object.freeze(EVENT_CATEGORY_IMAGES)
export type EVENT_CATEGORY_IMAGES = typeof EVENT_CATEGORY_IMAGES
